import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import PracticeAreas from "./components/PracticeAreas";
import Differentials from "./components/Differentials";
import CTASection from "./components/CTASection";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

export default function Home() {
  return (
    <main className="font-sans bg-white min-h-screen">
      <Navbar />
      <Hero />
      <PracticeAreas />
      <About />
      <Differentials />
      <CTASection />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
